import { em, math } from 'polished'
import styled from 'styled-components'

export const Item = styled.div`
  position: absolute;

  &.item-0 {
    top: 30%;
  }

  &.item-1 {
    top: 20%;
  }

  &.item-2 {
    top: 58%;
  }

  &.item-3 {
    top: 67%;
  }

  &.item-4 {
    top: 70%;
  }

  &.item-5 {
    top: 10%;
  }

  &.item-6 {
    top: 37%;
  }

  &.item-7 {
    top: 44%;
  }
`

export const LineWrapper = styled(Item)`
  display: inline-block;
  transform: translateX(-100%);
  height: ${p => math(`${em(16)} * ${p.theme.typography.baseLh}`)};

  &.line-0 {
    width: 20%;
  }

  &.line-1 {
    width: 20%;
  }

  &.line-2 {
    width: 26%;
  }

  &.line-3 {
    width: 40%;
  }

  &.line-4 {
    width: 20%;
  }

  &.line-5 {
    width: 16%;
  }

  &.line-6 {
    width: 20%;
  }

  &.line-7 {
    width: 20%;
  }
`
